import createProdStore from './createStore.prod'
import createDevStore  from './createStore.dev'

const createStore = (process.env.NODE_ENV === 'production') ? createProdStore : createDevStore

export default createStore



// WEBPACK FOOTER //
// ./react/store/createStore.js